import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG } from '../../config/siteConfig';
import { theme } from '../../theme/colors';
import { isPartnersHost } from '../../utils/hostNavigation';
import MarketingLink from '../MarketingLink/MarketingLink';
import '../../theme/auth-page.css';

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
  const logo = (
    <img src={theme.logo.url} alt={SITE_CONFIG.name} />
  );

  return (
    <div className="auth-page">
      <header className="auth-page-brand">
        {isPartnersHost() ? (
          <Link to="/signin" className="auth-page-logo" aria-label={SITE_CONFIG.name}>
            {logo}
          </Link>
        ) : (
          <MarketingLink href="/" className="auth-page-logo" aria-label={SITE_CONFIG.name}>
            {logo}
          </MarketingLink>
        )}
      </header>
      <div className="auth-page-main">{children}</div>
      <p className="auth-page-legal">
        By continuing, you agree to Peppar&apos;s{' '}
        <MarketingLink href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
          Terms of Service
        </MarketingLink>
        {' '}&amp;{' '}
        <MarketingLink href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </MarketingLink>
      </p>
    </div>
  );
};

export default AuthPageLayout;
